import { ClassAttributes, FC, FormEvent, FormEventHandler, FormHTMLAttributes, useEffect, useState } from 'react';

import * as S from './Form.style';
import { FormContextClass, FormContextProvider, IFormContext, useFormContext } from './form-context';

interface FormProps {
  onSubmit?: FormEventHandler<HTMLFormElement>;
  onMount?: (ctx: IFormContext) => void;
  onUnMount?: () => void;
}

const ChildForm: FC<FormProps & FormHTMLAttributes<HTMLFormElement> & ClassAttributes<HTMLFormElement>> = ({
  children,
  className,
  id,
  onSubmit,
  onMount,
  onUnMount,
  ...props
}): JSX.Element => {
  const formContext = useFormContext();
  const { checkForm } = formContext;

  const handleSubmit: FormEventHandler<HTMLFormElement> = (event: FormEvent<HTMLFormElement>) => {
    !checkForm() ? event.preventDefault() : onSubmit?.(event);
  };

  useEffect(() => {
    onMount?.(formContext);
    return onUnMount ?? (() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.Form className={className} id={id} onSubmit={handleSubmit} {...props}>
      {children}
    </S.Form>
  );
};

export const Form: FC<FormProps & FormHTMLAttributes<HTMLFormElement> & ClassAttributes<HTMLFormElement>> = ({
  children,
  className,
  id,
  onSubmit,
  ...props
}): JSX.Element => {
  const [formContextValue] = useState(new FormContextClass());

  return (
    <FormContextProvider value={formContextValue}>
      <ChildForm className={className} id={id} onSubmit={onSubmit} {...props}>
        {children}
      </ChildForm>
    </FormContextProvider>
  );
};
